import { type ServiceMethod } from '@/application/interfaces/service';

type Params = {
  productId: number;
};

export type Response = {
  data: SimilarProducts;
};

export type SimilarProducts = {
  title: string;
  slug: string;
  originProductId: number;
  products: Product[];
};
export type Product = {
  id: number;
  name: string;
  shortName: string;
  picture: string;
  unit: string;
  url: string;
  meta: {
    hasService: boolean;
    hasVariants: boolean;
    inWishlist: boolean;
    isOutlet: boolean;
    isSoldOut: boolean;
  };
  tag: {
    type: string;
    label: string;
  };
  installments: {
    amount: number;
    value: string;
  };
  price: {
    to: number;
    from: number | null;
    region: string;
    discount: {
      discountType: string;
      paymentMethodsDiscount: string;
    } | null;
  };
  brand: string;
  categoryTree: string;
  sellerName: string | null;
  skuId: string;
  translatedUnit: string;
};

const getSimilarProducts: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { productId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/crosses/{productId}/products',
      {
        ...options,
        params: { productId },
      }
    );

    return response;
  };

export default getSimilarProducts;
